import { HeadSection } from 'components/HeadSection';
import { HamperProvider } from 'contexts';
import { useRouter } from 'next/router';
import { PbServerSideProps } from '../getServerSideProps';
import { PbPage } from '../page';

export const PageBuilderDesktop: React.FC<PbServerSideProps> = (props) => {
  const { pbMetaData, name } = props;
  const { query } = useRouter();

  return (
    <>
      <HeadSection
        title={pbMetaData.metaTitle || name}
        metaTitle={pbMetaData.metaTitle}
        description={pbMetaData.metaDescription}
        canonical={pbMetaData.canonical}
        noindex={pbMetaData.noIndex}
        keywords={pbMetaData.metaKeywords?.join(',')}
        image={pbMetaData.metaImage}
        schemaPage={pbMetaData.jsonLd}
      />
      <HamperProvider>
        <PbPage {...props} page={query.slug as string} />
      </HamperProvider>
    </>
  );
};
